import React, { useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useQuery } from "@apollo/react-hooks";
import { Card, Button, Layout, Menu, Descriptions, Space, Tag } from "antd";
import { GetOrg } from "../../graphql/organization";
import { FundraiserCard } from "../../components/fundraiser/FundraiserCard";
import { FrOrganizerDlg } from "./components/OrganizerDlg";
import { AddAdminDlg } from "./components/AddAdminDlg";
import { observer } from "mobx-react";

const { Content, Sider } = Layout;
export const OrgFundraisings = observer(() => {
  let { id } = useParams<any>();
  // orgStore.active(id);
  const history = useHistory();

  const { data: { org } = { org: { id } }, refetch } = useQuery<any>(GetOrg, { variables: { id } });

  const [showSubDlg, setShowSubDlg] = useState(false);
  const [showAdd, setShowAdd] = useState(false);
  const [curSub, setCurSub] = useState("all");
  const [model, setModel] = useState({ id: null });

  const fo = org?.children?.find((x) => x.id === curSub);

  const onClose = () => {
    setShowSubDlg(false);
    setShowAdd(false);
    refetch();
  };
  const editSub = (m) => {
    setModel(m);
    setShowSubDlg(true);
  };

  const onSelect = (key) => {
    setCurSub(key + "");
    history.push(`/orgs/${id}/fundraising?funOrgId=${key === "all" ? "" : key}`);
  };

  return (
    <Layout>
      <Sider theme="light" style={{ marginRight: 15 }}>
        <Menu onClick={(e) => onSelect(e.key)} defaultSelectedKeys={["all"]} mode="inline">
          <Menu.Item key="all">All</Menu.Item>
          {org?.children?.map((c) => (
            <Menu.Item key={c.id}>{c.name}</Menu.Item>
          ))}
        </Menu>
        <Button block type="primary" onClick={() => editSub({ orgId: id })}>
          Add
        </Button>
      </Sider>
      <Content>
        {curSub !== "all" && (
          <Card>
            <Descriptions size="small" column={3}>
              <Descriptions.Item label="Name">{fo?.name}</Descriptions.Item>
              <Descriptions.Item label="Description">{fo?.description}</Descriptions.Item>
              <Descriptions.Item>
                <div style={{ width: "100%" }}>
                  <Button
                    style={{ float: "right" }}
                    size="small"
                    type="link"
                    onClick={() => editSub({ orgId: id, ...fo })}
                  >
                    Edit
                  </Button>
                </div>
              </Descriptions.Item>
              <Descriptions.Item label="Contact Name">{fo?.contactName}</Descriptions.Item>
              <Descriptions.Item label="Contact Phone">{fo?.contactPhone}</Descriptions.Item>
              <Descriptions.Item label="Contact Email">{fo?.contactEmail}</Descriptions.Item>
              <Descriptions.Item label="Bank Routing Number">{fo?.bankRouting}</Descriptions.Item>
              <Descriptions.Item label="Bank Account Number" span={2}>
                {fo?.bankAccount}
              </Descriptions.Item>
              <Descriptions.Item label="Permissioned Fundraiser" span={3}>
                <Space>
                  {fo?.admins.map((x) => (
                    <Tag key={x.id}>{x.name}</Tag>
                  ))}
                  <Button style={{ float: "right" }} size="small" type="link" onClick={() => setShowAdd(true)}>
                    Setup
                  </Button>
                </Space>
              </Descriptions.Item>
            </Descriptions>
          </Card>
        )}

        <FundraiserCard style={{ marginTop: curSub === "all" ? 0 : 15 }} />

        {showSubDlg && <FrOrganizerDlg model={model} onClose={() => onClose()} />}
        {showAdd && <AddAdminDlg org={org} funOrg={fo} onClose={onClose} />}
      </Content>
    </Layout>
  );
});
